<template>
  <div id="app">
    <v-app id="vuetify-root">
      <v-content v-resize="setWindowSize" :style="overflowStyle">
        <router-view />
        <loading-overlay v-if="isAuthenticated"/>
        <auto-logout-modal v-if="isAuthenticated" />
        <status-snackbar />
      </v-content>
    </v-app>
  </div>
</template>

<script>
import StatusSnackbar from "./components/misc/StatusSnackbar";
import autoLogoutModal from "./components/dialogs/AutoLogoutModal";
import { mapGetters, mapMutations } from "vuex";
import LoadingOverlay from "./components/misc/LoadingOverlay";
import router from "./router";

function maintainClass(key, className){
  return function(){
    if (this[key]) document.body.classList.add(className);
    else document.body.classList.remove(className);
  };
}

export default {
  components: { StatusSnackbar, autoLogoutModal, LoadingOverlay },
  computed: {
    ...mapGetters(["isAuthenticated", "isIE", "isIOS", "ssoEmrPro", "defaultColorTheme"]),
    overflowStyle() {
      if (router.history.getCurrentLocation() == "/login")
        return "overflow-y: auto;";
      return "";
    }
  },
  methods: {
    ...mapMutations(["setWindowSize"])
  },
  mounted() {
    this.setWindowSize();
    if (this.isIE) document.body.classList.add("is-ie");
    if (this.isIOS) document.body.classList.add("is-ios");
    if (this.ssoEmrPro) document.body.classList.add("sso-emr-pro");
    this.$vuetify.theme.dark = (this.defaultColorTheme != "white");
    this.$vuetify.theme.light = (this.defaultColorTheme == "white");
  },
  watch: {
    isIE: maintainClass("isIE", "is-ie"),
    isIOS: maintainClass("isIOS", "is-ios"),
    ssoEmrPro: maintainClass("ssoEmrPro", "sso-emr-pro"),
    defaultColorTheme: {
      handler(){
        this.$vuetify.theme.dark = (this.defaultColorTheme != "white");
        this.$vuetify.theme.light = (this.defaultColorTheme == "white");
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: white;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
